export enum ETypeTransactions {
    CREDIT_CARD = 0,
    PAY_ORDER = 1,
    SUBSCRIPTION = 3,
    PIX = 4
}